import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CategoryChip } from "@/components/CategoryChip";
import { TimeAgo } from "@/components/TimeAgo";
import { hr } from "@/constants/strings.hr";
import type { Article } from "@/types";

export function HeroArticle({ article }: { article: Article }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{ cursor: "pointer" }}
      onClick={() => navigate(`/clanak/${article.id}`)}
    >
      <CategoryChip name={article.category.name} />
      <Typography
        variant="h3"
        sx={{
          mt: 1.5,
          mb: 1,
          lineHeight: 1.2,
          "&:hover": { color: "secondary.main" },
        }}
      >
        {article.title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 2,
          lineHeight: 1.6,
        }}
      >
        {article.subtitle}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
          }}
        >
          {hr.article.byline}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          -
        </Typography>
        <TimeAgo date={article.createdAt} />
      </Box>
    </Box>
  );
}
